(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[804],{

/***/ 8009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fR": function() { return /* reexport */ Feed; },
  "SO": function() { return /* reexport */ Post; },
  "MB": function() { return /* reexport */ Preview; },
  "QV": function() { return /* reexport */ Writer; }
});

// UNUSED EXPORTS: Content

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ./features/blog/components/content/styles.module.scss
var styles_module = __webpack_require__(4842);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(8944);
// EXTERNAL MODULE: ./features/blog/helpers/index.ts + 7 modules
var helpers = __webpack_require__(1967);
;// CONCATENATED MODULE: ./features/blog/components/content/quote.tsx




function Quote(props) {
    const { className , text , caption  } = props;
    const preparedText = (0,helpers/* fixWordBreaks */.nf)(text);
    const preparedCaption = caption && (0,helpers/* fixWordBreaks */.nf)(caption);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
        className: (0,clsx_m/* clsx */.W)(className, (styles_module_default()).quote),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                className: (styles_module_default()).quote__container,
                dangerouslySetInnerHTML: {
                    __html: preparedText
                }
            }),
            caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                className: (styles_module_default()).quote__caption,
                dangerouslySetInnerHTML: {
                    __html: "— ".concat(preparedCaption)
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./features/blog/components/content/paragraph.tsx




function Paragraph(props) {
    const { className , text  } = props;
    const santitizedText = (0,helpers/* sanitizePostText */.iW)(text);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        dangerouslySetInnerHTML: {
            __html: santitizedText
        },
        className: (0,clsx_m/* clsx */.W)(className, (styles_module_default()).paragraph)
    });
}

;// CONCATENATED MODULE: ./features/blog/components/content/header.tsx




function Header(props) {
    const { className , text , level  } = props;
    const preparedText = (0,helpers/* fixWordBreaks */.nf)(text);
    switch(level){
        case 1:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                dangerouslySetInnerHTML: {
                    __html: preparedText
                },
                className: (0,clsx_m/* clsx */.W)(className, (styles_module_default()).header)
            });
        case 2:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                dangerouslySetInnerHTML: {
                    __html: preparedText
                },
                className: (0,clsx_m/* clsx */.W)(className, (styles_module_default()).header)
            });
        case 3:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                dangerouslySetInnerHTML: {
                    __html: preparedText
                },
                className: (0,clsx_m/* clsx */.W)(className, (styles_module_default()).header)
            });
        case 4:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                dangerouslySetInnerHTML: {
                    __html: preparedText
                },
                className: (0,clsx_m/* clsx */.W)(className, (styles_module_default()).header)
            });
        case 5:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                dangerouslySetInnerHTML: {
                    __html: preparedText
                },
                className: (0,clsx_m/* clsx */.W)(className, (styles_module_default()).header)
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                dangerouslySetInnerHTML: {
                    __html: preparedText
                },
                className: (0,clsx_m/* clsx */.W)(className, (styles_module_default()).header)
            });
    }
}

;// CONCATENATED MODULE: ./features/blog/components/content/delimiter.tsx



function Delimiter(props) {
    const { className  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* clsx */.W)(className, (styles_module_default()).delimiter)
    });
}

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ./features/ui/form/editor/plugins/embed/index.ts + 1 modules
var plugins_embed = __webpack_require__(4168);
// EXTERNAL MODULE: ../node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(597);
// EXTERNAL MODULE: ../node_modules/lodash/lodash.js
var lodash = __webpack_require__(8784);
;// CONCATENATED MODULE: ./features/blog/components/content/embed.tsx








function Embed(props) {
    const { className , input , provider , html , caption  } = props;
    const preparedCaption = caption && (0,helpers/* fixWordBreaks */.nf)((0,lodash.escape)(caption));
    const embedProvider = plugins_embed/* DefaultEmbedProviders */.r[provider];
    const onRef = (0,react.useCallback)((elem)=>{
        if (!elem) {
            return;
        }
        if (embedProvider) {
            embedProvider(input).then((result)=>{
                if (result) {
                    elem.innerHTML = result.html + elem.innerHTML;
                }
            }).catch(console.error);
        } else {
            elem.innerHTML = html + elem.innerHTML;
        }
    }, [
        html,
        input,
        embedProvider
    ]);
    const providerClasses = {
        instagram: (styles_module_default())["embed--provider-instagram"],
        twitter: (styles_module_default())["embed--provider-twitter"]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-provider": provider,
        "data-provider-input": input,
        className: (0,clsx_m/* clsx */.W)(className, (styles_module_default()).embed, providerClasses[provider]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* clsx */.W)((styles_module_default()).embed__container),
            ref: onRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).embed__loader,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiLoader */.dAq, {
                        size: "1em"
                    })
                }),
                preparedCaption && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).embed__caption,
                    dangerouslySetInnerHTML: {
                        __html: preparedCaption
                    }
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./features/blog/components/content/list.tsx




function List(props) {
    const { className , type , items  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* clsx */.W)(className, (styles_module_default()).list),
        children: [
            type === "ordered" && /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                children: items.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        dangerouslySetInnerHTML: {
                            __html: (0,helpers/* sanitizePostText */.iW)(item)
                        }
                    }, index))
            }),
            type === "unordered" && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: items.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        dangerouslySetInnerHTML: {
                            __html: (0,helpers/* sanitizePostText */.iW)(item)
                        }
                    }, index))
            })
        ]
    });
}

;// CONCATENATED MODULE: ./features/blog/components/content/unknown.tsx

function Unknown(props) {
    const { className  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: "Unknown content block type"
    });
}

;// CONCATENATED MODULE: ./features/blog/components/content/helpers.ts
function groupContent(content) {
    return content.reduce((groups, block)=>{
        var ref;
        const prevGroup = groups[groups.length - 1];
        const prevBlock = prevGroup === null || prevGroup === void 0 ? void 0 : prevGroup[prevGroup.length - 1];
        if ((ref = block.tunes) === null || ref === void 0 ? void 0 : ref["hidden"]) {
            return groups;
        }
        if ((prevBlock === null || prevBlock === void 0 ? void 0 : prevBlock.type) === "image" && block.type === "image" && !block.data["group"]) {
            prevGroup === null || prevGroup === void 0 ? void 0 : prevGroup.push(block);
        } else {
            groups.push([
                block
            ]);
        }
        return groups;
    }, []);
}

// EXTERNAL MODULE: ./features/blog/components/content/images/styles.module.scss
var images_styles_module = __webpack_require__(7840);
var images_styles_module_default = /*#__PURE__*/__webpack_require__.n(images_styles_module);
// EXTERNAL MODULE: ../node_modules/next/image.js
var next_image = __webpack_require__(8579);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./features/shared/image/helpers.ts
/* provided dependency */ var process = __webpack_require__(4284);
function canImageBeOptimized(src) {
    const domains = (process.env["NEXT_PUBLIC_IMAGE_DOMAINS"] || "").split(",").map((domain)=>domain.trim());
    if (typeof src === "string") {
        const url = new URL(src);
        return domains.indexOf(url.hostname) !== -1;
    }
    return true;
}

;// CONCATENATED MODULE: ./features/shared/image/index.ts


// EXTERNAL MODULE: ./features/ui/image-viewer/styles.module.scss
var image_viewer_styles_module = __webpack_require__(382);
var image_viewer_styles_module_default = /*#__PURE__*/__webpack_require__.n(image_viewer_styles_module);
// EXTERNAL MODULE: ../node_modules/react-dom/index.js
var react_dom = __webpack_require__(1542);
// EXTERNAL MODULE: ./features/ui/image-viewer/image-modal/styles.module.scss
var image_modal_styles_module = __webpack_require__(3546);
var image_modal_styles_module_default = /*#__PURE__*/__webpack_require__.n(image_modal_styles_module);
// EXTERNAL MODULE: ../node_modules/react-swipeable/es/index.js
var es = __webpack_require__(7485);
;// CONCATENATED MODULE: ./features/ui/image-viewer/image-viewer-context.ts

const ImageViewerContext = (0,react.createContext)({
    sources: []
});

;// CONCATENATED MODULE: ./features/ui/image-viewer/image-modal/use-image-modal.ts





function useImageModal(props) {
    const { onClose , src  } = props;
    const { sources  } = (0,react.useContext)(ImageViewerContext);
    const currentSources = (0,react.useMemo)(()=>{
        const allSources = [
            ...sources
        ];
        if (!allSources.includes(src)) {
            allSources.push(src);
        }
        return allSources;
    }, [
        sources,
        src
    ]);
    const [currentSrcIndex, setCurrentSrcIndex] = (0,react.useState)(currentSources.findIndex((value)=>value === src));
    const currentSrc = currentSources[currentSrcIndex] || src;
    const unoptimized = !canImageBeOptimized(src);
    const next = (0,react.useCallback)(()=>{
        const nextIndex = currentSrcIndex + 1 >= currentSources.length ? 0 : currentSrcIndex + 1;
        setCurrentSrcIndex(nextIndex);
    }, [
        currentSrcIndex,
        currentSources
    ]);
    const prev = (0,react.useCallback)(()=>{
        const prevIndex = currentSrcIndex - 1 < 0 ? currentSources.length - 1 : currentSrcIndex - 1;
        setCurrentSrcIndex(prevIndex);
    }, [
        currentSrcIndex,
        currentSources
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        const unscrollableClass = (image_modal_styles_module_default()).unscrollable;
        if (typeof unscrollableClass !== "string") {
            return;
        }
        const { scrollY  } = window;
        (ref = document.body.parentElement) === null || ref === void 0 ? void 0 : ref.classList.add(unscrollableClass);
        if (scrollY !== 0) {
            document.body.scrollTop = scrollY;
        }
        return ()=>{
            var ref;
            const { scrollTop  } = document.body;
            (ref = document.body.parentElement) === null || ref === void 0 ? void 0 : ref.classList.remove(unscrollableClass);
            window.scrollTo({
                top: scrollTop
            });
        };
    });
    (0,react.useEffect)(()=>{
        const onKeyDown = (e)=>{
            if ([
                "ArrowLeft",
                "Left"
            ].includes(e.key)) {
                prev();
            } else if ([
                "ArrowRight",
                " ",
                "Right"
            ].includes(e.key)) {
                next();
            } else if ([
                "Esc",
                "Escape",
                "Backspace"
            ].includes(e.key) && onClose) {
                onClose();
            }
        };
        document.addEventListener("keydown", onKeyDown);
        return ()=>{
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [
        onClose,
        prev,
        next
    ]);
    const swipeable = (0,es/* useSwipeable */.QS)({
        onSwipedLeft: next,
        onSwipedRight: prev,
        onSwipedUp: onClose
    });
    return {
        currentSrc,
        unoptimized,
        swipeable
    };
}

;// CONCATENATED MODULE: ./features/ui/image-viewer/image-modal/image-modal.tsx







function ImageModal(props) {
    const { className , onClose , src  } = props;
    const { currentSrc , unoptimized , swipeable  } = useImageModal({
        src,
        onClose
    });
    return /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ...swipeable,
        onClick: onClose,
        className: (image_modal_styles_module_default()).modal,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiLoader */.dAq, {
                className: (image_modal_styles_module_default()).modal__loader
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                className: (0,clsx_m/* clsx */.W)(className, (image_modal_styles_module_default()).modal__image),
                fill: true,
                alt: "",
                sizes: "100vw",
                src: currentSrc,
                unoptimized: unoptimized
            }, currentSrc)
        ]
    }), document.body);
}

;// CONCATENATED MODULE: ./features/ui/image-viewer/image-modal/index.ts


;// CONCATENATED MODULE: ./features/ui/image-viewer/image-viewer.tsx







function ImageViewer(props) {
    const { className , sizes , src , alt , width , height  } = props;
    const unoptimized = !canImageBeOptimized(src);
    const [isZoomed, setIsZoomed] = (0,react.useState)(false);
    const [isBrowser, setIsBrowser] = (0,react.useState)(false);
    const reZoom = (0,react.useCallback)(()=>{
        setIsZoomed(!isZoomed);
    }, [
        isZoomed
    ]);
    (0,react.useEffect)(()=>{
        setIsBrowser("object" !== "undefined");
    }, [
        isBrowser
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isZoomed && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageModal, {
                width: width || 1,
                height: height || 1,
                onClose: reZoom,
                src: src
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                onClick: reZoom,
                className: (0,clsx_m/* clsx */.W)(className, (image_viewer_styles_module_default()).image),
                width: width || 1,
                height: height || 1,
                alt: alt || "",
                sizes: sizes,
                src: src,
                unoptimized: unoptimized
            })
        ]
    });
}

;// CONCATENATED MODULE: ./features/ui/image-viewer/index.tsx



;// CONCATENATED MODULE: ./features/blog/components/content/images/picture.tsx





function Picture(props) {
    const { width , height , className , averageColor , withBorder , withBackground , caption , url , sizes  } = props;
    const imageStyle = (0,react.useMemo)(()=>{
        const style = {};
        if (averageColor) {
            style.background = "linear-gradient(-45deg,#282c35,".concat(averageColor, ",#282c35)");
            style.backgroundSize = "400% 400%";
        }
        return style;
    }, [
        averageColor
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* clsx */.W)(className, (images_styles_module_default()).picture, withBorder && (images_styles_module_default())["picture--withorder"], withBackground && (images_styles_module_default())["picture--with-background"]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: imageStyle,
            className: (images_styles_module_default()).picture__image,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageViewer, {
                width: width || 1,
                height: height || 1,
                alt: caption || "",
                sizes: sizes,
                src: url
            })
        })
    });
}

;// CONCATENATED MODULE: ./features/blog/components/content/images/images.tsx





function Images(props) {
    const { caption , blocks , className  } = props;
    const preparedCaption = caption && (0,helpers/* fixWordBreaks */.nf)(caption);
    const cols = Array.from(new Array(blocks.length > 4 ? 5 : blocks.length).keys());
    const rows = Array.from(new Array(Math.ceil(blocks.length / cols.length)).keys());
    const sizes = {
        1: "(max-width: 500px) 500px, 900px",
        2: "(max-width: 500px) 200px, 400px",
        3: "(max-width: 500px) 150px, 300px"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* clsx */.W)(className, (images_styles_module_default()).grid, (images_styles_module_default())["grid--cols-".concat(cols.length)]),
        children: [
            rows.map((row)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (images_styles_module_default()).grid__row,
                    children: cols.map((col)=>{
                        var ref, ref1, ref2, ref3, ref4, ref5;
                        const block = blocks[row * cols.length + col];
                        const width = (ref = block === null || block === void 0 ? void 0 : block.data["file"]) === null || ref === void 0 ? void 0 : (ref1 = ref["image"]) === null || ref1 === void 0 ? void 0 : ref1["width"];
                        const height = (ref2 = block === null || block === void 0 ? void 0 : block.data["file"]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2["image"]) === null || ref3 === void 0 ? void 0 : ref3["height"];
                        const averageColor = (ref4 = block === null || block === void 0 ? void 0 : block.data["file"]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4["image"]) === null || ref5 === void 0 ? void 0 : ref5["averageColor"];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (images_styles_module_default()).grid__col,
                            children: block && /*#__PURE__*/ (0,jsx_runtime.jsx)(Picture, {
                                averageColor: averageColor,
                                className: (images_styles_module_default()).grid__item,
                                url: block.data["file"].url,
                                sizes: sizes[cols.length] || "(max-width: 500px) 200px, 400px",
                                width: width,
                                height: height,
                                withBackground: block.data["withBackground"],
                                withBorder: block.data["withBorder"],
                                caption: block.data["caption"]
                            }, "".concat(row, "-").concat(col))
                        }, col);
                    })
                }, row);
            }),
            preparedCaption && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* clsx */.W)((images_styles_module_default()).caption),
                dangerouslySetInnerHTML: {
                    __html: preparedCaption
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./features/blog/components/content/images/index.ts


;// CONCATENATED MODULE: ./features/blog/components/content/external-link.tsx





function ExternalLink(props) {
    const { className , image , link , title , description  } = props;
    const preparedTitle = title && (0,helpers/* fixWordBreaks */.nf)((0,lodash.escape)(title));
    const preparedDescription = description && (0,helpers/* fixWordBreaks */.nf)((0,lodash.escape)(description));
    let anchor = link;
    try {
        const url = new URL(link);
        anchor = url.host;
    } catch (e) {
        console.log(e);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* clsx */.W)(className, (styles_module_default()).link),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: (styles_module_default()).link__content,
            href: link,
            rel: "nofollow noindex noreferrer noopener",
            target: "_blank",
            children: [
                image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).link__image,
                    style: {
                        backgroundImage: "url(".concat(image, ")")
                    }
                }),
                preparedTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).link__title,
                    dangerouslySetInnerHTML: {
                        __html: preparedTitle
                    }
                }),
                preparedDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (styles_module_default()).link__description,
                    dangerouslySetInnerHTML: {
                        __html: preparedDescription
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (styles_module_default()).link__anchor,
                    children: anchor
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./features/blog/components/content/personality.tsx




function Personality(props) {
    const { className , image , description , name , link  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* clsx */.W)(className, (styles_module_default()).personality),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).personality__content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).personality__name,
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).personality__description,
                        children: description
                    }),
                    link && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        rel: "nofollow noindex noreferrer noopener",
                        href: link,
                        className: (styles_module_default()).personality__link,
                        children: link
                    })
                ]
            }),
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["personality__image-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageViewer, {
                    className: (styles_module_default()).personality__image,
                    alt: name,
                    src: image,
                    sizes: "(max-width: 499px) 500px, (max-width: 749px) 350px, 300px"
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./features/blog/components/content/content.tsx















function Content(props) {
    const { blocks , className  } = props;
    const groups = groupContent(blocks);
    const sources = groups.reduce((all, blocks)=>{
        for (const block of blocks){
            if (block.type === "image") {
                all.push(block.data["file"].url);
            }
        }
        return all;
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageViewerContext.Provider, {
        value: {
            sources
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx_m/* clsx */.W)((styles_module_default()).content, className),
            children: groups.map((group, groupIndex)=>{
                if (group[0] && group[0].type !== "image") {
                    const block = group[0];
                    switch(block.type){
                        case "quote":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Quote, {
                                className: (styles_module_default()).content__block,
                                text: block.data["text"],
                                caption: block.data["caption"]
                            }, groupIndex);
                        case "paragraph":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                className: (styles_module_default()).content__block,
                                text: block.data["text"]
                            }, groupIndex);
                        case "personality":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Personality, {
                                name: block.data["name"],
                                description: block.data["description"],
                                link: block.data["link"],
                                image: block.data["photo"],
                                className: (styles_module_default()).content__block
                            }, groupIndex);
                        case "header":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                                className: (styles_module_default()).content__block,
                                level: block.data["level"],
                                text: block.data["text"]
                            }, groupIndex);
                        case "externalLink":
                            var ref;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExternalLink, {
                                className: (styles_module_default()).content__block,
                                title: block.data["meta"]["title"],
                                description: block.data["meta"]["description"],
                                image: (ref = block.data["meta"]["image"]) === null || ref === void 0 ? void 0 : ref["url"],
                                link: block.data["link"]
                            }, groupIndex);
                        case "delimiter":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Delimiter, {
                                className: (styles_module_default()).content__block
                            }, groupIndex);
                        case "embed":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Embed, {
                                className: (styles_module_default()).content__block,
                                caption: block.data["caption"],
                                input: block.data["input"],
                                provider: block.data["provider"],
                                html: block.data["html"]
                            }, groupIndex);
                        case "list":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                                className: (styles_module_default()).content__block,
                                type: block.data["style"],
                                items: block.data["items"]
                            }, groupIndex);
                        default:
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Unknown, {}, groupIndex);
                    }
                } else {
                    var ref1, ref2;
                    const caption = (ref1 = group[group.length - 1]) === null || ref1 === void 0 ? void 0 : ref1.data["caption"];
                    const nextGroup = groups[groupIndex + 1];
                    const nextIsImage = (nextGroup === null || nextGroup === void 0 ? void 0 : (ref2 = nextGroup[(nextGroup === null || nextGroup === void 0 ? void 0 : nextGroup.length) - 1]) === null || ref2 === void 0 ? void 0 : ref2["type"]) === "image";
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Images, {
                        blocks: group,
                        caption: caption,
                        className: (0,clsx_m/* clsx */.W)((styles_module_default()).content__block, nextIsImage && !caption && (styles_module_default())["content__block--small-bottom-margin"])
                    }, groupIndex);
                }
            })
        })
    });
}

;// CONCATENATED MODULE: ./features/blog/components/content/index.tsx


// EXTERNAL MODULE: ./features/blog/components/feed/styles.module.scss
var feed_styles_module = __webpack_require__(7758);
var feed_styles_module_default = /*#__PURE__*/__webpack_require__.n(feed_styles_module);
// EXTERNAL MODULE: ./features/blog/components/feed/text-post/styles.module.scss
var text_post_styles_module = __webpack_require__(996);
var text_post_styles_module_default = /*#__PURE__*/__webpack_require__.n(text_post_styles_module);
// EXTERNAL MODULE: ../node_modules/next/link.js
var next_link = __webpack_require__(9894);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../node_modules/react-icons/bs/index.esm.js
var bs_index_esm = __webpack_require__(4212);
// EXTERNAL MODULE: ./features/i18n/index.ts + 2 modules
var features_i18n = __webpack_require__(9194);
// EXTERNAL MODULE: ../node_modules/react-tooltip/dist/react-tooltip.esm.min.js
var react_tooltip_esm_min = __webpack_require__(1819);
// EXTERNAL MODULE: ./features/ui/tooltip/styles.module.scss
var tooltip_styles_module = __webpack_require__(6539);
var tooltip_styles_module_default = /*#__PURE__*/__webpack_require__.n(tooltip_styles_module);
;// CONCATENATED MODULE: ./features/ui/tooltip/tooltip.tsx



function Tooltip(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_tooltip_esm_min/* Tooltip */.u, {
        ...props,
        className: (tooltip_styles_module_default()).tooltip
    });
}

;// CONCATENATED MODULE: ./features/ui/tooltip/index.ts


;// CONCATENATED MODULE: ./features/blog/components/feed/text-post/title.tsx








function Title(props) {
    const { id , url , title , translation  } = props;
    const { i18n  } = (0,features_i18n/* useI18n */.QT)();
    const preparedTitle = (0,helpers/* fixWordBreaks */.nf)((0,lodash.escape)(title || i18n("emptyPreview")));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                className: (text_post_styles_module_default()).title,
                children: [
                    translation && /*#__PURE__*/ (0,jsx_runtime.jsx)(bs_index_esm/* BsTranslate */.S7c, {
                        id: "".concat(id, "-translation-icon"),
                        className: (text_post_styles_module_default())["title__translation-icon"]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: url,
                        dangerouslySetInnerHTML: {
                            __html: preparedTitle
                        }
                    })
                ]
            }),
            translation && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip, {
                anchorId: "".concat(id, "-translation-icon"),
                content: i18n("thisIsTranslation")
            })
        ]
    });
}

;// CONCATENATED MODULE: ./features/blog/components/feed/text-post/quote.tsx




function quote_Quote(props) {
    const { text , caption , url  } = props;
    const preparedText = (0,helpers/* fixWordBreaks */.nf)(text);
    const preparedCaption = caption && (0,helpers/* fixWordBreaks */.nf)(caption);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
        className: (text_post_styles_module_default()).quote,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                className: (text_post_styles_module_default()).quote__container,
                dangerouslySetInnerHTML: {
                    __html: preparedText
                }
            }),
            preparedCaption && /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                className: (text_post_styles_module_default()).quote__caption,
                dangerouslySetInnerHTML: {
                    __html: "— ".concat(preparedCaption)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                className: (text_post_styles_module_default()).quote__link,
                href: url
            })
        ]
    });
}

;// CONCATENATED MODULE: ./features/blog/components/feed/text-post/personality.tsx







function personality_Personality(props) {
    const { className , url , name , description , image  } = props;
    const fixedName = (0,helpers/* fixWordBreaks */.nf)(name);
    const preparedDescription = description && (0,helpers/* fixWordBreaks */.nf)((0,lodash.truncate)(description, {
        length: 240
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)(className, (text_post_styles_module_default()).personality),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (text_post_styles_module_default()).personality__content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (text_post_styles_module_default()).personality__name,
                        children: fixedName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (text_post_styles_module_default()).personality__description,
                        dangerouslySetInnerHTML: {
                            __html: preparedDescription
                        }
                    })
                ]
            }),
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (text_post_styles_module_default())["personality__image-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: (text_post_styles_module_default()).personality__image,
                    alt: name,
                    fill: true,
                    src: image,
                    sizes: "(max-width: 499px) 500px, (max-width: 749px) 350px, 300px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                className: (text_post_styles_module_default()).personality__link,
                href: url
            })
        ]
    });
}

;// CONCATENATED MODULE: ./features/blog/components/feed/text-post/text-post.tsx







function TextPost(props) {
    const { post , className  } = props;
    const cover = (0,helpers/* getCover */.sF)(post.content);
    const url = (0,helpers/* getPostUrl */.uR)({
        id: post.id,
        slug: post.slug || undefined
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* clsx */.W)(className, (text_post_styles_module_default())["text-post"]),
        children: [
            (cover === null || cover === void 0 ? void 0 : cover.type) !== "quote" && (cover === null || cover === void 0 ? void 0 : cover.type) !== "personality" && (post.title || !post.title && !cover) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                id: "post-".concat(post.id),
                url: url,
                title: post.title || undefined,
                translation: post.tags.includes("перевод") || post.tags.includes("translation")
            }),
            (cover === null || cover === void 0 ? void 0 : cover.type) === "paragraph" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (text_post_styles_module_default())["text-post__text"],
                dangerouslySetInnerHTML: {
                    __html: (0,helpers/* sanitizePostText */.iW)(cover.data["text"])
                }
            }),
            (cover === null || cover === void 0 ? void 0 : cover.type) === "quote" && /*#__PURE__*/ (0,jsx_runtime.jsx)(quote_Quote, {
                url: url,
                text: cover.data["text"],
                caption: cover.data["caption"]
            }),
            (cover === null || cover === void 0 ? void 0 : cover.type) === "personality" && /*#__PURE__*/ (0,jsx_runtime.jsx)(personality_Personality, {
                url: url,
                name: cover.data["name"],
                description: cover.data["description"],
                image: cover.data["photo"]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./features/blog/components/feed/text-post/index.ts


;// CONCATENATED MODULE: ./features/blog/components/feed/helpers.ts

function groupPosts(posts) {
    let prevDateGroup;
    let prevPostCover = undefined;
    return posts.reduce((groups, post)=>{
        const postCover = (0,helpers/* getCover */.sF)(post.content);
        const postPublishedAt = new Date(post.publishedAt);
        let currentDateGroup = prevDateGroup;
        if (!currentDateGroup || currentDateGroup.month !== postPublishedAt.getMonth() + 1 || currentDateGroup.year !== postPublishedAt.getFullYear()) {
            currentDateGroup = {
                month: postPublishedAt.getMonth() + 1,
                year: postPublishedAt.getFullYear(),
                posts: []
            };
            groups.push(currentDateGroup);
        }
        const postsGroup = currentDateGroup.posts[currentDateGroup.posts.length - 1];
        if ((postCover === null || postCover === void 0 ? void 0 : postCover.type) === "image" && (prevPostCover === null || prevPostCover === void 0 ? void 0 : prevPostCover.type) === "image" && postsGroup) {
            postsGroup.push(post);
        } else {
            currentDateGroup.posts.push([
                post
            ]);
        }
        prevDateGroup = currentDateGroup;
        prevPostCover = postCover;
        return groups;
    }, []);
}

// EXTERNAL MODULE: ./features/blog/components/feed/images/styles.module.scss
var feed_images_styles_module = __webpack_require__(3462);
var feed_images_styles_module_default = /*#__PURE__*/__webpack_require__.n(feed_images_styles_module);
;// CONCATENATED MODULE: ./features/blog/components/feed/images/image-link.tsx








function ImageLink(props) {
    var ref, ref1;
    const { post , className , sizes  } = props;
    const cover = (0,helpers/* getCover */.sF)(post.content);
    const averageColor = (ref = cover === null || cover === void 0 ? void 0 : cover.data["file"]) === null || ref === void 0 ? void 0 : (ref1 = ref["image"]) === null || ref1 === void 0 ? void 0 : ref1["averageColor"];
    const imageStyle = (0,react.useMemo)(()=>{
        const style = {};
        if (averageColor) {
            style.background = "linear-gradient(-45deg,#282c35,".concat(averageColor, ",#282c35)");
            style.backgroundSize = "400% 400%";
        }
        return style;
    }, [
        averageColor
    ]);
    if ((cover === null || cover === void 0 ? void 0 : cover.type) !== "image") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "Not an image"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        style: imageStyle,
        className: (0,clsx_m/* clsx */.W)(className, (feed_images_styles_module_default()).link),
        href: (0,helpers/* getPostUrl */.uR)({
            id: post.id,
            slug: post.slug || undefined
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            className: (feed_images_styles_module_default()).image,
            alt: "",
            fill: true,
            sizes: sizes,
            src: cover.data["file"].url,
            unoptimized: !canImageBeOptimized(cover.data["file"].url)
        })
    }, post.id);
}

;// CONCATENATED MODULE: ./features/blog/components/feed/images/grid.tsx




function Grid(props) {
    const { posts , className  } = props;
    const cols = Array.from(new Array(posts.length > 4 ? 5 : posts.length).keys());
    const rows = Array.from(new Array(Math.ceil(posts.length / cols.length)).keys());
    const sizes = {
        1: "(max-width: 500px) 500px, 900px",
        2: "(max-width: 500px) 200px, 400px",
        3: "(max-width: 500px) 150px, 300px"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* clsx */.W)(className, (feed_images_styles_module_default()).grid, (feed_images_styles_module_default())["grid--cols-".concat(cols.length)]),
        children: rows.map((row)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (feed_images_styles_module_default()).grid__row,
                children: cols.map((col)=>{
                    const post = posts[row * cols.length + col];
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (feed_images_styles_module_default()).grid__col,
                        children: post && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                            sizes: sizes[cols.length] || "(max-width: 500px) 200px, 400px",
                            className: (feed_images_styles_module_default()).grid__item,
                            post: post
                        })
                    }, col);
                })
            }, row);
        })
    });
}

;// CONCATENATED MODULE: ./features/blog/components/feed/images/layout5.tsx




function Layout5(props) {
    const { posts , className  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-5"], className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (feed_images_styles_module_default())["layout-5__col"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                    sizes: "(max-width: 600px) 300px, 400px",
                    className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-5__item"], (feed_images_styles_module_default())["layout-5__item-1"]),
                    post: posts[0]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (feed_images_styles_module_default())["layout-5__col"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 300px, 400px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-5__item"], (feed_images_styles_module_default())["layout-5__item-2"]),
                        post: posts[1]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 300px, 400px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-5__item"], (feed_images_styles_module_default())["layout-5__item-3"]),
                        post: posts[2]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (feed_images_styles_module_default())["layout-5__col"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 300px, 400px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-5__item"], (feed_images_styles_module_default())["layout-5__item-4"]),
                        post: posts[3]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 300px, 400px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-5__item"], (feed_images_styles_module_default())["layout-5__item-5"]),
                        post: posts[4]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./features/blog/components/feed/images/layout6.tsx




function Layout6(props) {
    const { posts , className  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-6"], className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (feed_images_styles_module_default())["layout-6__col"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 300px, 400px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-6__item"], (feed_images_styles_module_default())["layout-6__item-1"]),
                        post: posts[0]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 300px, 400px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-6__item"], (feed_images_styles_module_default())["layout-6__item-2"]),
                        post: posts[1]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (feed_images_styles_module_default())["layout-6__col"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 300px, 400px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-6__item"], (feed_images_styles_module_default())["layout-6__item-3"]),
                        post: posts[2]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 300px, 400px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-6__item"], (feed_images_styles_module_default())["layout-6__item-4"]),
                        post: posts[3]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (feed_images_styles_module_default())["layout-6__col"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 300px, 400px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-6__item"], (feed_images_styles_module_default())["layout-6__item-5"]),
                        post: posts[4]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 300px, 400px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-6__item"], (feed_images_styles_module_default())["layout-6__item-6"]),
                        post: posts[5]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./features/blog/components/feed/images/layout7.tsx




function Layout7(props) {
    const { posts , className  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-7"], className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (feed_images_styles_module_default())["layout-7__col"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                    sizes: "(max-width: 600px) 200px, 300px",
                    className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-7__item"], (feed_images_styles_module_default())["layout-7__item-1"]),
                    post: posts[0]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (feed_images_styles_module_default())["layout-7__col"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 200px, 300px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-7__item"], (feed_images_styles_module_default())["layout-7__item-2"]),
                        post: posts[1]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 200px, 300px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-7__item"], (feed_images_styles_module_default())["layout-7__item-3"]),
                        post: posts[2]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (feed_images_styles_module_default())["layout-7__col"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 200px, 300px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-7__item"], (feed_images_styles_module_default())["layout-7__item-4"]),
                        post: posts[3]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 200px, 300px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-7__item"], (feed_images_styles_module_default())["layout-7__item-5"]),
                        post: posts[4]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (feed_images_styles_module_default())["layout-7__col"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 200px, 300px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-7__item"], (feed_images_styles_module_default())["layout-7__item-6"]),
                        post: posts[5]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 200px, 300px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-7__item"], (feed_images_styles_module_default())["layout-7__item-7"]),
                        post: posts[6]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./features/blog/components/feed/images/layout8.tsx




function Layout8(props) {
    const { posts , className  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-8"], className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (feed_images_styles_module_default())["layout-8__col"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 300px, 400px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-8__item"], (feed_images_styles_module_default())["layout-8__item-1"]),
                        post: posts[0]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 200px, 300px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-8__item"], (feed_images_styles_module_default())["layout-8__item-2"]),
                        post: posts[1]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (feed_images_styles_module_default())["layout-8__col"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 200px, 300px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-8__item"], (feed_images_styles_module_default())["layout-8__item-3"]),
                        post: posts[2]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 200px, 300px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-8__item"], (feed_images_styles_module_default())["layout-8__item-4"]),
                        post: posts[3]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (feed_images_styles_module_default())["layout-8__col"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 200px, 300px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-8__item"], (feed_images_styles_module_default())["layout-8__item-5"]),
                        post: posts[4]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 200px, 300px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-8__item"], (feed_images_styles_module_default())["layout-8__item-6"]),
                        post: posts[5]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (feed_images_styles_module_default())["layout-8__col"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 200px, 300px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-8__item"], (feed_images_styles_module_default())["layout-8__item-7"]),
                        post: posts[6]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                        sizes: "(max-width: 600px) 200px, 300px",
                        className: (0,clsx_m/* clsx */.W)((feed_images_styles_module_default())["layout-8__item"], (feed_images_styles_module_default())["layout-8__item-8"]),
                        post: posts[7]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./features/blog/components/feed/images/images.tsx






function hasLength(posts, length) {
    return posts.length === length;
}
function images_Images(props) {
    const { posts , className  } = props;
    if (hasLength(posts, 5)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout5, {
            className: className,
            posts: posts
        });
    } else if (hasLength(posts, 6)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout6, {
            className: className,
            posts: posts
        });
    } else if (hasLength(posts, 7)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout7, {
            className: className,
            posts: posts
        });
    } else if (hasLength(posts, 8)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout8, {
            className: className,
            posts: posts
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid, {
        className: className,
        posts: posts
    });
}

;// CONCATENATED MODULE: ./features/blog/components/feed/images/index.ts


;// CONCATENATED MODULE: ./features/blog/components/feed/feed.tsx








function Feed(props) {
    const { posts  } = props;
    const dateGroups = groupPosts(posts);
    const { i18n  } = (0,features_i18n/* useI18n */.QT)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (feed_styles_module_default()).feed,
        children: dateGroups.map((dateGroup)=>{
            var ref;
            const monthName = (ref = i18n("months")[dateGroup.month - 1]) === null || ref === void 0 ? void 0 : ref[0];
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (feed_styles_module_default())["feed__date-group"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (feed_styles_module_default()).feed__date,
                        children: [
                            monthName,
                            " ",
                            dateGroup.year
                        ]
                    }),
                    dateGroup.posts.map((postsGroup, postsGroupIndex)=>{
                        var ref;
                        if (postsGroup.length === 1 && postsGroup[0] && ((ref = (0,helpers/* getCover */.sF)(postsGroup[0].content)) === null || ref === void 0 ? void 0 : ref.type) !== "image") {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextPost, {
                                className: (feed_styles_module_default()).feed__post,
                                post: postsGroup[0]
                            }, postsGroupIndex);
                        } else {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(images_Images, {
                                className: (0,clsx_m/* clsx */.W)((feed_styles_module_default()).feed__post, (feed_styles_module_default())["feed__post--images"]),
                                posts: postsGroup
                            }, postsGroupIndex);
                        }
                    })
                ]
            }, "".concat(dateGroup.month, "-").concat(dateGroup.year));
        })
    });
}

;// CONCATENATED MODULE: ./features/blog/components/feed/index.ts


// EXTERNAL MODULE: ./features/blog/components/post/styles.module.scss
var post_styles_module = __webpack_require__(599);
var post_styles_module_default = /*#__PURE__*/__webpack_require__.n(post_styles_module);
;// CONCATENATED MODULE: ./features/blog/components/post/helpers.ts
function getPublicationDateString(date) {
    const { day , hours , month , minutes , year , currentYear  } = date;
    let dateString = "".concat(day, " ").concat(month);
    if (year !== currentYear) {
        dateString += " ".concat(year);
    }
    dateString += ", ".concat(hours.toString().padStart(2, "0"), ":").concat(minutes.toString().padStart(2, "0"));
    return dateString;
}

;// CONCATENATED MODULE: ./features/blog/components/post/meta.tsx






function Meta(props) {
    const { date , className  } = props;
    const { i18n  } = (0,features_i18n/* useI18n */.QT)();
    const [publicationDate, setPublicationDate] = (0,react.useState)(()=>{
        var ref;
        const day = date.getUTCDate();
        const month = date.getUTCMonth();
        const monthName = (ref = i18n("months")[month]) === null || ref === void 0 ? void 0 : ref[1];
        const hours = date.getUTCHours();
        const minutes = date.getUTCMinutes();
        const year = date.getUTCFullYear();
        const currentYear = new Date().getUTCFullYear();
        return getPublicationDateString({
            day,
            month: monthName || "Unknown month",
            hours,
            minutes,
            year,
            currentYear
        });
    });
    (0,react.useEffect)(()=>{
        var ref;
        const day = date.getDate();
        const month = date.getMonth();
        const monthName = (ref = i18n("months")[month]) === null || ref === void 0 ? void 0 : ref[1];
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const year = date.getFullYear();
        const currentYear = new Date().getFullYear();
        return setPublicationDate(getPublicationDateString({
            day,
            month: monthName || "Unknown month",
            hours,
            minutes,
            year,
            currentYear
        }));
    }, [
        date,
        i18n
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* clsx */.W)((post_styles_module_default()).meta, className),
        children: publicationDate
    });
}

;// CONCATENATED MODULE: ./features/blog/components/post/title.tsx







function title_Title(props) {
    const { id , title , translation  } = props;
    const { i18n  } = (0,features_i18n/* useI18n */.QT)();
    const preparedTitle = (0,helpers/* fixWordBreaks */.nf)((0,lodash.escape)(title));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                className: (post_styles_module_default()).title,
                children: [
                    " ",
                    translation && /*#__PURE__*/ (0,jsx_runtime.jsx)(bs_index_esm/* BsTranslate */.S7c, {
                        id: "".concat(id, "-translation-icon"),
                        className: (post_styles_module_default())["title__translation-icon"]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: preparedTitle
                        }
                    })
                ]
            }),
            translation && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip, {
                anchorId: "".concat(id, "-translation-icon"),
                content: i18n("thisIsTranslation")
            })
        ]
    });
}

;// CONCATENATED MODULE: ./features/blog/components/post/post.tsx






function Post(props) {
    const { date , tags , title , content  } = props;
    const cover = (0,helpers/* getCover */.sF)(content);
    const hideTitle = (cover === null || cover === void 0 ? void 0 : cover.type) === "personality" && content[0] === cover;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (post_styles_module_default()).post,
        children: [
            date && /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta, {
                className: (post_styles_module_default()).post__meta,
                date: date
            }),
            title && !hideTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(title_Title, {
                id: "title",
                translation: (tags === null || tags === void 0 ? void 0 : tags.includes("перевод")) || (tags === null || tags === void 0 ? void 0 : tags.includes("translation")),
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                className: (post_styles_module_default()).post__content,
                blocks: content
            })
        ]
    });
}

;// CONCATENATED MODULE: ./features/blog/components/post/index.tsx


// EXTERNAL MODULE: ./features/blog/components/preview/styles.module.scss
var preview_styles_module = __webpack_require__(5411);
var preview_styles_module_default = /*#__PURE__*/__webpack_require__.n(preview_styles_module);
;// CONCATENATED MODULE: ./features/blog/components/preview/picture.tsx




function picture_Picture(props) {
    const { url  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (preview_styles_module_default()).image,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            sizes: "(max-width: 499px) 500px, (max-width: 749px) 350px, 300px",
            alt: "",
            fill: true,
            unoptimized: !canImageBeOptimized(url),
            src: url
        })
    });
}

;// CONCATENATED MODULE: ./features/blog/components/preview/quote.tsx


function preview_quote_Quote(props) {
    const { text , caption , alignment  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            (preview_styles_module_default()).quote,
            alignment === "center" && (preview_styles_module_default())["quote--align-center"]
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                dangerouslySetInnerHTML: {
                    __html: text
                }
            }),
            caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("cite", {
                dangerouslySetInnerHTML: {
                    __html: "– ".concat(caption)
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./features/blog/components/preview/paragraph.tsx


function paragraph_Paragraph(props) {
    const { title , text  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (preview_styles_module_default()).paragraph,
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                dangerouslySetInnerHTML: {
                    __html: title
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                dangerouslySetInnerHTML: {
                    __html: text
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./features/blog/components/preview/title.tsx


function preview_title_Title(props) {
    const { title  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (preview_styles_module_default()).title,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
            dangerouslySetInnerHTML: {
                __html: title
            }
        })
    });
}

;// CONCATENATED MODULE: ./features/blog/components/preview/empty.tsx



function Empty() {
    const { i18n  } = (0,features_i18n/* useI18n */.QT)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (preview_styles_module_default()).empty,
        children: i18n("emptyPreview")
    });
}

;// CONCATENATED MODULE: ./features/blog/components/preview/preview.tsx










function Preview(props) {
    const { title , url , content , className  } = props;
    const cover = (0,helpers/* getCover */.sF)(content);
    const renderPreview = ()=>{
        switch(cover === null || cover === void 0 ? void 0 : cover.type){
            case "quote":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(preview_quote_Quote, {
                    alignment: cover.data["alignment"],
                    text: cover.data["text"],
                    caption: cover.data["caption"]
                });
            case "image":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_Picture, {
                    url: cover.data["file"].url
                });
            case "paragraph":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph_Paragraph, {
                    title: title,
                    text: cover.data["text"]
                });
            default:
                if (title) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(preview_title_Title, {
                        title: title
                    });
                } else {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Empty, {});
                }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: (0,clsx_m/* clsx */.W)((preview_styles_module_default()).post, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                className: (preview_styles_module_default()).post__link,
                href: url
            }),
            renderPreview()
        ]
    });
}

;// CONCATENATED MODULE: ./features/blog/components/preview/index.tsx


// EXTERNAL MODULE: ./features/blog/components/writer/styles.module.scss
var writer_styles_module = __webpack_require__(6063);
var writer_styles_module_default = /*#__PURE__*/__webpack_require__.n(writer_styles_module);
// EXTERNAL MODULE: ./features/ui/form/index.tsx + 5 modules
var ui_form = __webpack_require__(6596);
// EXTERNAL MODULE: ../node_modules/luxon/src/luxon.js + 23 modules
var luxon = __webpack_require__(3860);
;// CONCATENATED MODULE: ./features/blog/components/writer/helpers.ts

function toRelative(text) {
    const date = luxon/* DateTime.fromISO */.ou.fromISO(text);
    return Math.abs(date.diffNow().as("seconds")) <= 5 ? "just now" : date.toRelative() || "";
}

// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(5218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./features/ui/modal/styles.module.scss
var modal_styles_module = __webpack_require__(9080);
var modal_styles_module_default = /*#__PURE__*/__webpack_require__.n(modal_styles_module);
;// CONCATENATED MODULE: ./features/ui/modal/use-modal.tsx

function useModal(props) {
    const { onClose  } = props;
    const ref = (0,react.useRef)(null);
    const onClick = (0,react.useCallback)((e)=>{
        var ref1;
        const shouldClose = e.target instanceof Node && !((ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.contains(e.target));
        if (shouldClose && onClose) {
            onClose();
        }
    }, [
        onClose
    ]);
    return {
        ref,
        onClick
    };
}

;// CONCATENATED MODULE: ./features/ui/modal/modal.tsx




function Modal(props) {
    const { onClick , ref  } = useModal(props);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onClick: onClick,
        className: (0,clsx_m/* clsx */.W)((modal_styles_module_default()).container, props.className, !props.visible && (modal_styles_module_default()).container_hidden),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (modal_styles_module_default()).background
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (modal_styles_module_default()).container_modal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: ref,
                    className: (modal_styles_module_default()).modal,
                    children: props.children
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./features/ui/modal/index.tsx


// EXTERNAL MODULE: ./features/ui/main/index.tsx + 7 modules
var main = __webpack_require__(3634);
// EXTERNAL MODULE: ./features/ui/form/form.module.scss
var form_module = __webpack_require__(5344);
var form_module_default = /*#__PURE__*/__webpack_require__.n(form_module);
// EXTERNAL MODULE: ../node_modules/react-select/dist/react-select.esm.js
var react_select_esm = __webpack_require__(823);
;// CONCATENATED MODULE: ./features/ui/form/select.tsx




function Select(props) {
    const { defaultValue , placeholder , name , multi , validationError , label , noOptionsMessage , options , onChange  } = props;
    const inputRef = (0,react.useRef)();
    const onInputRef = (0,react.useCallback)((elem)=>{
        inputRef.current = elem;
        if (inputRef.current) {
            inputRef.current.value = defaultValue ? JSON.stringify(defaultValue) : multi ? "[]" : "";
        }
    }, [
        multi,
        defaultValue
    ]);
    const onSelectChange = (0,react.useCallback)((values)=>{
        if (inputRef.current) {
            inputRef.current.value = JSON.stringify(values);
        }
        if (onChange) {
            // @ts-expect-error: TODO: fix
            onChange(Array.isArray(values) ? [
                ...values
            ] : values);
        }
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (form_module_default()).select,
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                children: label
            }),
            name && /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                ref: onInputRef,
                type: "hidden",
                name: name + "--json"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
                placeholder: placeholder,
                noOptionsMessage: ()=>noOptionsMessage || null,
                defaultValue: defaultValue,
                onChange: onSelectChange,
                options: options,
                isMulti: multi,
                classNamePrefix: "react-select"
            }),
            validationError && (Array.isArray(validationError) ? validationError : [
                validationError
            ]).map((error, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (form_module_default()).form__validationError,
                    children: error
                }, index))
        ]
    });
}

// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(6677);
// EXTERNAL MODULE: ./features/blog/queries/index.ts + 10 modules
var queries = __webpack_require__(6104);
;// CONCATENATED MODULE: ./features/blog/components/writer/use-writer.ts




function useWriter() {
    let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const [isOptionsModalVisible, setIsOptionsModalVisible] = (0,react.useState)(false);
    const [draft, setDraft] = (0,react.useState)(options.draft);
    // TODO: fix
    const [validationErrors, setValidationErrors] = (0,react.useState)({});
    const editorRef = (0,react.useRef)(null);
    const formRef = (0,react.useRef)(null);
    const router = (0,next_router.useRouter)();
    const updateDraft = (0,queries/* useUpdateDraft */.Wk)({
        onSuccess (data) {
            setDraft(data);
        }
    });
    const createDraft = (0,queries/* useCreateDraft */.Z8)({
        onSuccess (data) {
            setDraft(data);
            if (options.onCreate) {
                options.onCreate(data);
            }
        }
    });
    const publishDraft = (0,queries/* usePublishDraft */.ov)({
        onSuccess (data) {
            setDraft(data);
        }
    });
    const resetDraft = (0,queries/* useResetDraft */.Gb)({
        onSuccess () {
            router.reload();
        }
    });
    const unpublishDraft = (0,queries/* useUnpublishDraft */.cT)({
        onSuccess (data) {
            setDraft(data);
        }
    });
    const removeDraft = (0,queries/* useRemoveDraft */.AN)({
        onSuccess () {
            router.push((draft === null || draft === void 0 ? void 0 : draft.postPublishedAt) ? "/" : "/drafts");
        }
    });
    const [, setTime] = (0,react.useState)();
    const { i18n , locale  } = (0,features_i18n/* useI18n */.QT)();
    const formLocaleOption = (locale)=>{
        switch(locale){
            case "en":
                return {
                    label: i18n("englishLanguage"),
                    value: locale
                };
            case "ru":
                return {
                    label: i18n("russianLanguage"),
                    value: locale
                };
            default:
                return {
                    label: locale,
                    value: locale
                };
        }
    };
    const languageOptions = features_i18n/* LOCALES.map */.lE.map(formLocaleOption);
    const selectedLanguages = (draft ? draft.languages : [
        locale
    ]).map(formLocaleOption);
    const selectedTags = (draft ? draft.tags : []).map((tag)=>({
            label: tag,
            value: tag
        }));
    const showOptionsModal = (0,react.useCallback)(()=>{
        setIsOptionsModalVisible(true);
    }, []);
    const hideOptionsModal = (0,react.useCallback)(()=>{
        setIsOptionsModalVisible(false);
    }, []);
    const publish = (0,react.useCallback)(()=>{
        if (draft) {
            publishDraft.mutate({
                id: draft === null || draft === void 0 ? void 0 : draft.id
            });
        }
    }, [
        publishDraft,
        draft
    ]);
    const unpublish = (0,react.useCallback)(()=>{
        if (draft) {
            unpublishDraft.mutate({
                id: draft === null || draft === void 0 ? void 0 : draft.id
            });
            setIsOptionsModalVisible(false);
        }
    }, [
        unpublishDraft,
        draft
    ]);
    const isUpdating = unpublishDraft.isLoading || publishDraft.isLoading || resetDraft.isLoading || createDraft.isLoading || updateDraft.isLoading || removeDraft.isLoading;
    const remove = (0,react.useCallback)(()=>{
        if (!draft || isUpdating) {
            return;
        }
        if (!confirm(i18n("areYouSure"))) {
            return;
        }
        setIsOptionsModalVisible(false);
        removeDraft.mutate({
            id: draft.id
        });
    }, [
        draft,
        removeDraft,
        i18n,
        isUpdating
    ]);
    const reset = (0,react.useCallback)(()=>{
        if (!draft || isUpdating) {
            return;
        }
        if (!confirm(i18n("areYouSure"))) {
            return;
        }
        resetDraft.mutate({
            id: draft.id
        });
    }, [
        draft,
        isUpdating,
        i18n,
        resetDraft
    ]);
    (0,react.useEffect)(()=>{
        const id = setInterval(()=>{
            setTime(Date.now());
        }, 1000);
        return ()=>{
            clearInterval(id);
        };
    }, []);
    const focusOnContent = (0,react.useCallback)((e)=>{
        if (e.key.toLowerCase() === "enter") {
            var ref;
            e.preventDefault();
            (ref = editorRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        }
    }, []);
    const submit = (0,react.useCallback)(()=>{
        var ref;
        (ref = formRef.current) === null || ref === void 0 ? void 0 : ref.submit();
    }, []);
    const save = (0,react.useCallback)((data)=>{
        if (isUpdating) {
            return;
        }
        setValidationErrors({});
        const title = data.title.trim();
        const secret = data.draftSecret.trim();
        const content = data.content.filter((block)=>!!block.data);
        const languages = data.languages.map((option)=>option.value);
        const tags = data.tags.map((option)=>option.value);
        const publishedAt = isNaN(new Date(data.publishedAt).getTime()) ? null : data.publishedAt;
        if (content.length === 0) {
            return;
        }
        const payload = {
            title,
            content,
            languages,
            tags,
            secret,
            publishedAt
        };
        if (draft) {
            updateDraft.mutate({
                id: draft.id,
                data: payload
            });
        } else {
            createDraft.mutate(payload);
        }
    }, [
        updateDraft,
        createDraft,
        draft,
        isUpdating
    ]);
    return {
        save,
        submit,
        focusOnContent,
        formRef,
        remove,
        publish,
        unpublish,
        showOptionsModal,
        reset,
        draft,
        isUpdating,
        isOptionsModalVisible,
        hideOptionsModal,
        validationErrors,
        selectedLanguages,
        languageOptions,
        selectedTags,
        editorRef,
        i18n
    };
}

;// CONCATENATED MODULE: ./features/blog/components/writer/writer.tsx











const Editor = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(625), __webpack_require__.e(789), __webpack_require__.e(862)]).then(__webpack_require__.bind(__webpack_require__, 7862)).then((res)=>res.Editor), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(7862)
            ]
    },
    ssr: false
});
function Writer(props) {
    var ref;
    const { formRef , save , submit , draft , publish , isUpdating , showOptionsModal , reset , isOptionsModalVisible , hideOptionsModal , validationErrors , selectedLanguages , languageOptions , selectedTags , unpublish , remove , focusOnContent , editorRef , i18n  } = useWriter({
        draft: props.draft,
        onCreate: props.onCreate
    });
    return(// @ts-expect-error: TODO: Fix
    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* Form */.l0, {
        apiRef: formRef,
        onSubmit: save,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(main/* Main */.o, {
            rightSidebar: draft && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* clsx */.W)((writer_styles_module_default()).sidebar),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (writer_styles_module_default()).sidebar__topContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (writer_styles_module_default()).sidebar__top,
                            children: [
                                !draft.postPublished && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* Button */.zx, {
                                    className: (writer_styles_module_default()).sidebar__item,
                                    type: "button",
                                    disabled: isUpdating,
                                    onClick: publish,
                                    block: true,
                                    children: i18n("publishDraft")
                                }),
                                draft.postPublished && !draft.published && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* Button */.zx, {
                                    className: (writer_styles_module_default()).sidebar__item,
                                    type: "button",
                                    disabled: isUpdating,
                                    onClick: publish,
                                    block: true,
                                    children: i18n("publishDraftChanges")
                                }),
                                !draft.published && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* Button */.zx, {
                                    className: (writer_styles_module_default()).sidebar__item,
                                    type: "link",
                                    style: "outlined",
                                    target: "_blank",
                                    disabled: isUpdating,
                                    href: "/draft/".concat(draft.id, "?secret=").concat(draft.secret),
                                    block: true,
                                    children: i18n("previewDraft")
                                }),
                                draft.postPublished && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* Button */.zx, {
                                    className: (writer_styles_module_default()).sidebar__item,
                                    type: "link",
                                    target: "_blank",
                                    style: "outlined",
                                    disabled: isUpdating,
                                    href: (0,helpers/* getPostUrl */.uR)({
                                        id: draft.id,
                                        slug: draft.postSlug || undefined
                                    }),
                                    block: true,
                                    children: i18n("openPost")
                                }),
                                !draft.postPublished && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* clsx */.W)((writer_styles_module_default()).sidebar__item, (writer_styles_module_default()).sidebar__label),
                                    children: [
                                        "Saved ",
                                        toRelative(draft.updatedAt)
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (writer_styles_module_default()).sidebar__bottom,
                        children: [
                            draft.postPublished && !draft.published && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* Button */.zx, {
                                className: (writer_styles_module_default()).sidebar__item,
                                type: "button",
                                style: "outlined",
                                disabled: isUpdating,
                                onClick: reset,
                                block: true,
                                children: i18n("resetDraft")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* Button */.zx, {
                                className: (0,clsx_m/* clsx */.W)((writer_styles_module_default()).sidebar__item, (writer_styles_module_default()).sidebar__item_large),
                                style: "void",
                                type: "button",
                                loading: isUpdating,
                                onClick: showOptionsModal,
                                block: true,
                                children: "•••"
                            })
                        ]
                    })
                ]
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
                    className: (writer_styles_module_default()).modal,
                    visible: isOptionsModalVisible,
                    onClose: hideOptionsModal,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Select, {
                            placeholder: i18n("selectPlaceholder"),
                            validationError: Array.isArray(validationErrors["languages"]) ? validationErrors["languages"].map((error)=>error.key === "arrayNotEmpty" ? i18n("draftLanguagesIsRequired") : error.message) : undefined,
                            name: "languages",
                            label: i18n("draftLanguages"),
                            defaultValue: selectedLanguages,
                            onChange: submit,
                            options: languageOptions,
                            multi: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* CreatableSelect */.a7, {
                            placeholder: i18n("selectPlaceholder"),
                            name: "tags",
                            label: i18n("draftTags"),
                            multi: true,
                            onChange: submit,
                            defaultValue: selectedTags
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* Input */.II, {
                            label: i18n("draftSecret"),
                            name: "draftSecret",
                            defaultValue: (draft === null || draft === void 0 ? void 0 : draft.secret) || "",
                            onChange: submit
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* Input */.II, {
                            label: i18n("draftPublishDate"),
                            name: "publishedAt",
                            defaultValue: (draft === null || draft === void 0 ? void 0 : draft.publishedAt) || "",
                            onChange: submit
                        }),
                        draft && draft.published && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* Button */.zx, {
                            disabled: isUpdating,
                            className: (writer_styles_module_default()).modal__action,
                            style: "outlined",
                            block: true,
                            onClick: unpublish,
                            type: "button",
                            children: i18n("unpublishDraft")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* Button */.zx, {
                            onClick: remove,
                            disabled: isUpdating,
                            className: (writer_styles_module_default()).modal__action,
                            style: "danger",
                            block: true,
                            type: "button",
                            children: i18n("deleteDraft")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (writer_styles_module_default()).form,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* Textarea */.gx, {
                            name: "title",
                            defaultValue: ((ref = props.draft) === null || ref === void 0 ? void 0 : ref.title) || undefined,
                            onInput: submit,
                            autoSize: true,
                            onKeyDown: focusOnContent,
                            className: (writer_styles_module_default()).form__title,
                            placeholder: i18n("draftTitlePlaceholder")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (writer_styles_module_default()).form__content,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor, {
                                className: "writer",
                                name: "content",
                                defaultValue: props.draft && props.draft.content,
                                placeholder: i18n("draftContentPlaceholder"),
                                apiRef: editorRef,
                                onChange: submit
                            })
                        })
                    ]
                })
            ]
        })
    }));
}

;// CONCATENATED MODULE: ./features/blog/components/writer/index.tsx


;// CONCATENATED MODULE: ./features/blog/components/index.ts







/***/ }),

/***/ 1967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nf": function() { return /* reexport */ fixWordBreaks; },
  "sF": function() { return /* reexport */ getCover; },
  "T3": function() { return /* reexport */ getDraftUrl; },
  "uR": function() { return /* reexport */ getPostUrl; },
  "Jh": function() { return /* reexport */ getSeoDescription; },
  "UX": function() { return /* reexport */ getSeoImage; },
  "iW": function() { return /* reexport */ sanitizePostText; }
});

;// CONCATENATED MODULE: ./features/blog/helpers/get-cover.ts
function getCover(content) {
    return content.find((block)=>{
        var ref;
        return !!((ref = block.tunes) === null || ref === void 0 ? void 0 : ref["cover"]);
    });
}

;// CONCATENATED MODULE: ./features/blog/helpers/get-post-url.ts
function getPostUrl(components) {
    const { id , slug  } = components;
    return "/post/".concat(slug ? "".concat(slug, "-") : "").concat(id);
}

;// CONCATENATED MODULE: ./features/blog/helpers/get-seo-image.ts

function getSeoImage(content) {
    const cover = getCover(content);
    if ((cover === null || cover === void 0 ? void 0 : cover.type) === "image") {
        return cover.data["file"].url;
    }
    const block = content.find((block)=>{
        var ref;
        return block.type === "image" && !((ref = block.tunes) === null || ref === void 0 ? void 0 : ref["hidden"]);
    });
    if (block) {
        return block.data["file"].url;
    }
}

;// CONCATENATED MODULE: ./features/blog/helpers/get-draft-url.ts
function getDraftUrl(components) {
    const { id , edit , secret  } = components;
    let link = "/draft/".concat(id);
    if (edit) {
        link += "/edit";
    }
    if (secret) {
        link += "?secret=".concat(secret);
    }
    return link;
}

;// CONCATENATED MODULE: ./features/blog/helpers/fix-word-breaks.ts
function fixWordBreaks(html) {
    const noBreak = "(из-за|из-под)";
    const withNext = "(а|в|во|въ|да|и|к|ко|къ|о|об|обо|объ|с|со|cъ|у|без|для|до|за|из|изъ|или|на|над|не|ни|но|от|отъ|по|под|при|про|a|an|as|and|&|at|but|by|for|in|no|not|of|or|per|the|to|$|€|\xa3)";
    const withPrev = "(б|бы|ж|же|ль|ли|₽|\\$|€|\xa3)";
    let result = html;
    for(let i = 0; i < 10; i++){
        let fixedHtml = result;
        fixedHtml = fixedHtml.replaceAll(new RegExp("^".concat(noBreak, "([\\s<,.?!:;\"'])"), "iug"), "[<nowrap>]$1[</nowrap>]$2").replaceAll(new RegExp("([\\s,.>?!:;\"'])".concat(noBreak, "([\\s,<.?!:;\"'])"), "iug"), "$1[<nowrap>]$2[</nowrap>]$3").replaceAll(new RegExp("([\\s,>.?!:;\"'])".concat(noBreak, "$"), "iug"), "$1[<nowrap>]$2[</nowrap>]");
        fixedHtml = fixedHtml.replaceAll(new RegExp("^".concat(withNext, " "), "iug"), "$1&nbsp;").replaceAll(new RegExp("([\\s,.?!>:;\"'])".concat(withNext, " "), "iug"), "$1$2&nbsp;");
        fixedHtml = fixedHtml.replaceAll(new RegExp(" ".concat(withPrev, "$"), "iug"), "&nbsp;$1").replaceAll(new RegExp(" ".concat(withPrev, "([\\s,.?!:;\"'<])"), "iug"), "&nbsp;$1$2");
        if (fixedHtml === result) {
            break;
        } else {
            result = fixedHtml;
        }
    }
    result = result.replaceAll("[<nowrap>]", '<span style="white-space: nowrap">');
    result = result.replaceAll("[</nowrap>]", "</span>");
    return result;
}

;// CONCATENATED MODULE: ./features/blog/helpers/sanitize-post-text.ts

function sanitizePostText(html) {
    return fixWordBreaks(html.replaceAll(/<a([\s]+[^<>]+)>/g, '<a$1 rel="nofollow noindex noreferrer noopener" target="_blank">'));
}

// EXTERNAL MODULE: ../node_modules/lodash/lodash.js
var lodash = __webpack_require__(8784);
;// CONCATENATED MODULE: ./features/blog/helpers/get-seo-description.ts


function getSeoDescription(content) {
    let description;
    const cover = getCover(content);
    if ((cover === null || cover === void 0 ? void 0 : cover.type) === "paragraph") {
        description = cover.data["text"];
    }
    if (typeof description !== "string") {
        const block = content.find((block)=>{
            var ref;
            return block.type === "paragraph" && !((ref = block.tunes) === null || ref === void 0 ? void 0 : ref["hidden"]);
        });
        description = block === null || block === void 0 ? void 0 : block.data["text"];
    }
    if (typeof description !== "string" || description.length === 0) {
        return;
    }
    description = description.replaceAll(/<[^<>]+>/g, "").trim();
    if (description.length > 160) {
        description = (0,lodash.trimEnd)(description.substring(0, 160), ".").trimEnd() + "...";
    }
    return description;
}

;// CONCATENATED MODULE: ./features/blog/helpers/index.ts









/***/ }),

/***/ 6104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z8": function() { return /* reexport */ useCreateDraft; },
  "LH": function() { return /* reexport */ useDraft; },
  "Bb": function() { return /* reexport */ useDrafts; },
  "kx": function() { return /* reexport */ usePosts; },
  "ov": function() { return /* reexport */ usePublishDraft; },
  "AN": function() { return /* reexport */ useRemoveDraft; },
  "Gb": function() { return /* reexport */ useResetDraft; },
  "cT": function() { return /* reexport */ useUnpublishDraft; },
  "Wk": function() { return /* reexport */ useUpdateDraft; },
  "El": function() { return /* reexport */ useViewPost; }
});

// EXTERNAL MODULE: ./features/shared/api/index.ts + 9 modules
var shared_api = __webpack_require__(5815);
// EXTERNAL MODULE: ../node_modules/react-query/es/index.js
var es = __webpack_require__(6552);
;// CONCATENATED MODULE: ./features/blog/queries/use-posts.ts


function usePosts(props) {
    const { languages , tags , limit , initialData , staleTime =60000 , refetchInterval =60000  } = props;
    const api = (0,shared_api/* useApi */.h_)();
    const postsQuery = (0,es.useInfiniteQuery)([
        "api/posts",
        {
            languages,
            tags,
            limit
        }
    ], async (context)=>{
        const page = context.pageParam || 1;
        const res = await api.blog.findPosts({
            tags,
            languages,
            limit,
            offset: (page - 1) * limit
        });
        return res.data;
    }, {
        getNextPageParam: (lastPage, pages)=>{
            const total = pages.reduce((cur, prev)=>{
                return cur + prev.posts.length;
            }, 0);
            if (total < lastPage.total) {
                return pages.length + 1;
            }
        },
        initialData: ()=>initialData && {
                pageParams: [
                    undefined
                ],
                pages: initialData
            },
        staleTime,
        refetchInterval
    });
    return postsQuery;
}

// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(6677);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
;// CONCATENATED MODULE: ./features/blog/queries/use-draft.ts



function useDraft(props) {
    const { id , secret , redirectIfNotFound , redirectIfForbidden , refetchInterval  } = props;
    const api = (0,shared_api/* useApi */.h_)();
    const { hasToken  } = (0,shared_api/* useApiCredentials */.d9)();
    const draftQuery = (0,shared_api/* useApiQuery */.WE)([
        "api/draft",
        {
            id
        }
    ], async ()=>{
        const res = await api.blog.findDraftById(id, {
            secret
        });
        return res.data;
    }, {
        enabled: secret || redirectIfForbidden || redirectIfNotFound ? true : hasToken,
        refetchInterval
    });
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        if (draftQuery.isError && draftQuery.error instanceof Response && draftQuery.error.status === 404 && redirectIfNotFound) {
            router.push(redirectIfNotFound);
        } else if (draftQuery.isError && draftQuery.error instanceof Response && draftQuery.error.status === 403 && redirectIfForbidden) {
            router.push(redirectIfForbidden);
        }
    }, [
        draftQuery.isError,
        draftQuery.error,
        redirectIfNotFound,
        redirectIfForbidden,
        router
    ]);
    return draftQuery;
}

;// CONCATENATED MODULE: ./features/blog/queries/use-view-post.ts


function useViewPost() {
    const api = (0,shared_api/* useApi */.h_)();
    const mutation = (0,es.useMutation)("api/post", async (payload)=>{
        await api.blog.viewPost(payload.id);
    });
    return mutation;
}

;// CONCATENATED MODULE: ./features/blog/queries/use-create-draft.ts


function useCreateDraft() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { onSuccess  } = props;
    const api = (0,shared_api/* useApi */.h_)();
    const mutation = (0,es.useMutation)([
        "api/draft/create"
    ], async (payload)=>{
        const res = await api.blog.createDraft(payload);
        return res.data;
    }, {
        onSuccess
    });
    return mutation;
}

;// CONCATENATED MODULE: ./features/blog/queries/use-update-draft.ts


function useUpdateDraft() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { onSuccess  } = props;
    const api = (0,shared_api/* useApi */.h_)();
    const queryClient = (0,es.useQueryClient)();
    const mutation = (0,es.useMutation)("api/draft/update", async (payload)=>{
        const res = await api.blog.updateDraft(payload.id, payload.data);
        return res.data;
    }, {
        onSuccess (data) {
            queryClient.setQueryData([
                "api/post",
                {
                    id: data.id,
                    secret: data.secret
                }
            ], data);
            queryClient.setQueryData([
                "api/post",
                {
                    id: data.id
                }
            ], data);
            if (onSuccess) {
                onSuccess(data);
            }
        }
    });
    return mutation;
}

;// CONCATENATED MODULE: ./features/blog/queries/use-unpublish-draft.ts


function useUnpublishDraft() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { onSuccess  } = props;
    const api = (0,shared_api/* useApi */.h_)();
    const mutation = (0,es.useMutation)("api/draft/unpublish", async (payload)=>{
        const res = await api.blog.unpublishDraft(payload.id);
        return res.data;
    }, {
        onSuccess
    });
    return mutation;
}

;// CONCATENATED MODULE: ./features/blog/queries/use-publish-draft.ts


function usePublishDraft() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { onSuccess  } = props;
    const api = (0,shared_api/* useApi */.h_)();
    const mutation = (0,es.useMutation)("api/draft/publish", async (payload)=>{
        const res = await api.blog.publishDraft(payload.id);
        return res.data;
    }, {
        onSuccess
    });
    return mutation;
}

;// CONCATENATED MODULE: ./features/blog/queries/use-remove-draft.ts


function useRemoveDraft() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { onSuccess  } = props;
    const api = (0,shared_api/* useApi */.h_)();
    const mutation = (0,es.useMutation)("api/draft/remove", async (payload)=>{
        await api.blog.removeDraft(payload.id);
    }, {
        onSuccess
    });
    return mutation;
}

;// CONCATENATED MODULE: ./features/blog/queries/use-reset-draft.ts


function useResetDraft() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { onSuccess  } = props;
    const api = (0,shared_api/* useApi */.h_)();
    const mutation = (0,es.useMutation)("api/draft/reset", async (payload)=>{
        const res = await api.blog.resetDraft(payload.id);
        return res.data;
    }, {
        onSuccess
    });
    return mutation;
}

;// CONCATENATED MODULE: ./features/blog/queries/use-drafts.ts

function useDrafts(props) {
    const { languages , tags , limit , initialData  } = props;
    const api = (0,shared_api/* useApi */.h_)();
    const { hasToken  } = (0,shared_api/* useApiCredentials */.d9)();
    const postsQuery = (0,shared_api/* useApiInfiniteQuery */.gb)([
        "api/drafts",
        {
            languages,
            tags,
            limit
        }
    ], async (context)=>{
        const page = context.pageParam || 1;
        const res = await api.blog.findDrafts({
            tags,
            languages,
            limit,
            offset: (page - 1) * limit
        });
        return res.data;
    }, {
        getNextPageParam: (lastPage, pages)=>{
            const total = pages.reduce((cur, prev)=>{
                return cur + prev.drafts.length;
            }, 0);
            if (total < lastPage.total) {
                return pages.length + 1;
            }
        },
        initialData: ()=>initialData && {
                pageParams: [
                    undefined
                ],
                pages: initialData
            },
        enabled: hasToken
    });
    return postsQuery;
}

;// CONCATENATED MODULE: ./features/blog/queries/index.ts












/***/ }),

/***/ 4168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* reexport */ DefaultEmbedProviders; },
  "c": function() { return /* reexport */ tool/* Embed */.c; }
});

;// CONCATENATED MODULE: ./features/ui/form/editor/plugins/embed/providers.ts
const resizerScript = "var i=setInterval(()=>{if(!this.contentWindow){clearInterval(i);return;};var newHeight = this.contentWindow.document.body.scrollHeight+'px';if(this.height === newHeight){return;};this.height=newHeight}, 500);";
const DefaultEmbedProviders = {
    twitter: async (e)=>{
        const m = e.match(/<blockquote class="twitter-tweet"([^<>]*)>.*?((?:https?:\/\/)?(?:www\.)?twitter\.com\/([^/]+)\/status\/([0-9]+)).*?<\/blockquote>/i) || e.match(/((?:https?:\/\/)?(?:www\.)?twitter\.com\/([^/]+)\/status\/([0-9]+))/i);
        if (!m) {
            return Promise.resolve(undefined);
        }
        const id = m.length === 5 ? m[4] : m[3];
        const username = m.length === 4 ? m[3] : m[2];
        const config = (m[1] && m.length === 5 ? m[1] : "").replace(/"/g, "'");
        const url = "https://twitter.com/".concat(username, "/status/").concat(id);
        const html = '<iframe data-loading="true" onload="this.dataset.loading =\'false\';' + resizerScript + '" style="width:100%;max-width:550px;border:0px" srcdoc="<html><head><style>body,html,.twitter-tweet{padding:0!important;margin:0!important}</style></head><body><blockquote class=\'twitter-tweet\'' + config + "><a href='" + url + "'></a></blockquote> <script async src='https://platform.twitter.com/widgets.js' charset='utf-8'></script></body></html>\"></iframe>";
        return Promise.resolve({
            html,
            url
        });
    },
    jsfiddle: async (e)=>{
        const m = e.match(/((?:https?:\/\/)?(?:www\.)?jsfiddle\.net\/([^/]+)\/([^/]+)\/([0-9]+)([^"&?]*))/i) || e.match(/((?:https?:\/\/)?(?:www\.)?jsfiddle\.net\/([^/]+)\/([^/]+)([^"&?]+))/i);
        if (!m) {
            return Promise.resolve(undefined);
        }
        const id = m[3];
        const n = m.length === 6 ? m[4] : 1;
        const username = m[2];
        const config = m.length === 6 ? m[5] : m[4];
        if (!config) {
            throw new Error("Invalid config");
        }
        const url = "https://jsfiddle.net/".concat(username, "/").concat(id, "/").concat(n);
        const scriptUrl = url + (config.startsWith("/embed") ? config.replace("/embed/", "/embedded/") : "/embedded");
        const html = '<iframe data-loading="true" onload="this.dataset.loading =\'false\';" width="100%" height="300px" src="' + scriptUrl + '" allowfullscreen="allowfullscreen" allowpaymentrequest frameborder="0"></iframe>';
        return Promise.resolve({
            html,
            url
        });
    },
    instagram: async (e)=>{
        const m = e.match(/((?:https?:\/\/)?(?:www\.)?instagram\.com\/(?:p|reel)\/([^/?#&]+)).*/i);
        if (!m || !m[2]) {
            return;
        }
        const id = m[2];
        const url = "https://www.instagram.com/p/" + id;
        const html = '<iframe data-loading="true" onload="this.dataset.loading =\'false\';' + resizerScript + '" style="width: 100%; border:0;" sandbox="allow-same-origin allow-scripts allow-popups" scrolling="no" srcdoc="<html><head><style>body,html{padding:0!important;margin:0!important}</style></head><body><blockquote class=\'instagram-media\' data-instgrm-captioned data-instgrm-permalink=\'https://www.instagram.com/p/' + id + "/?utm_source=ig_embed&amp;utm_campaign=loading' data-instgrm-version='13' style=' background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; padding:0; width:100%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);'><div style='padding:16px;'> <a href='https://www.instagram.com/p/" + id + "/?utm_source=ig_embed&amp;utm_campaign=loading' style=' background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;' target='_blank'> <div style=' display: flex; flex-direction: row; align-items: center;'> <div style='background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;'></div> <div style='display: flex; flex-direction: column; flex-grow: 1; justify-content: center;'> <div style=' background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;'></div> <div style=' background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;'></div></div></div><div style='padding: 19% 0;'></div> <div style='display:block; height:50px; margin:0 auto 12px; width:50px;'><svg width='50px' height='50px' viewBox='0 0 60 60' version='1.1' xmlns='https://www.w3.org/2000/svg' xmlns:xlink='https://www.w3.org/1999/xlink'><g stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g transform='translate(-511.000000, -20.000000)' fill='#000000'><g><path d='M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631'></path></g></g></g></svg></div><div style='padding-top: 8px;'> <div style=' color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:550; line-height:18px;'> View this post on Instagram</div></div><div style='padding: 12.5% 0;'></div> <div style='display: flex; flex-direction: row; margin-bottom: 14px; align-items: center;'><div> <div style='background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(0px) translateY(7px);'></div> <div style='background-color: #F4F4F4; height: 12.5px; transform: rotate(-45deg) translateX(3px) translateY(1px); width: 12.5px; flex-grow: 0; margin-right: 14px; margin-left: 2px;'></div> <div style='background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(9px) translateY(-18px);'></div></div><div style='margin-left: 8px;'> <div style=' background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px;'></div> <div style=' width: 0; height: 0; border-top: 2px solid transparent; border-left: 6px solid #f4f4f4; border-bottom: 2px solid transparent; transform: translateX(16px) translateY(-4px) rotate(30deg)'></div></div><div style='margin-left: auto;'> <div style=' width: 0px; border-top: 8px solid #F4F4F4; border-right: 8px solid transparent; transform: translateY(16px);'></div> <div style=' background-color: #F4F4F4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px);'></div> <div style=' width: 0; height: 0; border-top: 8px solid #F4F4F4; border-left: 8px solid transparent; transform: translateY(-4px) translateX(8px);'></div></div></div> <div style='display: flex; flex-direction: column; flex-grow: 1; justify-content: center; margin-bottom: 24px;'> <div style=' background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 224px;'></div> <div style=' background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 144px;'></div></div></a><p style=' color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;'><a href='https://www.instagram.com/p/" + id + "/?utm_source=ig_embed&amp;utm_campaign=loading' style=' color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none;' target='_blank'>Instagram Post</a></p></div></blockquote> <script async src='//www.instagram.com/embed.js'></script></body></html>\"></iframe>";
        return Promise.resolve({
            html,
            url
        });
    },
    youtube: async (e)=>{
        const m = e.match(/((?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([^/#&]+)(?:&t=([0-9]+))?)/i) || e.match(/((?:https?:\/\/)?(?:www\.)?youtu.be\/([^/#?&]+)(?:\?t=([0-9]+))?)/i);
        if (!m) {
            return Promise.resolve(undefined);
        }
        const id = m[2];
        const startAt = typeof m[3] === "string" ? parseInt(m[3], 10) : 0;
        const url = "https://youtu.be/".concat(id).concat(startAt ? "?t=".concat(startAt) : "");
        return Promise.resolve({
            html: "<iframe data-loading='true' onload=\"this.dataset.loading ='false';\" style='width: 100%; height: 400px' src='https://www.youtube.com/embed/".concat(id).concat(startAt ? "?start=".concat(startAt) : "", "' title='YouTube video player' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>"),
            url
        });
    },
    githubGist: async (e)=>{
        const m = e.match(/((?:https?:\/\/)?gist\.github\.com\/([^/]+)\/([^/#&]+))/i);
        if (!m) {
            return Promise.resolve(undefined);
        }
        const id = m[3];
        const username = m[2];
        const url = "https://gist.github.com/".concat(username, "/").concat(id);
        const html = "<iframe srcdoc=\"<!doctype html><html><head><style>body,html{padding:0;margin:0}</style></head><body><script src='" + url + ".js'></script><script>window.addEventListener('load', () => {Array.from(document.getElementsByTagName('a')).forEach(a => {a.target = '_blank'})})</script></body></html>\" data-loading=\"true\" onload=\"this.dataset.loading ='false';" + resizerScript + '" style="border:0;width:100%" sandbox="allow-same-origin allow-scripts allow-popups" scrolling="no"></iframe>';
        return Promise.resolve({
            html,
            url
        });
    },
    telegram: async (e)=>{
        const m = e.match(/((?:https?:\/\/)?(?:www\.)?t\.me\/([^/]+)\/([0-9]+)).*/i);
        if (!m || !m[2] || !m[3]) {
            return;
        }
        const username = m[2];
        const postId = m[3];
        const url = "https://t.me/".concat(username, "/").concat(postId);
        const html = '<iframe data-loading="true" onload="this.dataset.loading =\'false\';' + resizerScript + '" style="width: 100%; max-width:500px;border:0;" sandbox="allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox" scrolling="no" srcdoc="<!doctype html><html><head><style>body,html{padding:0!important;margin:0!important}</style></head><body><script async src=\'https://telegram.org/js/telegram-widget.js?15\' data-telegram-post=\'' + username + "/" + postId + "' data-width='100%'></script></body>\"></iframe>";
        return Promise.resolve({
            html,
            url
        });
    }
};

// EXTERNAL MODULE: ./features/ui/form/editor/plugins/embed/tool.ts
var tool = __webpack_require__(2490);
;// CONCATENATED MODULE: ./features/ui/form/editor/plugins/embed/index.ts




/***/ }),

/***/ 2490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ Embed; }
/* harmony export */ });
const Embed = class {
    createContainerElem() {
        const containerElem = document.createElement("div");
        containerElem.classList.add(this.api.styles.block);
        containerElem.classList.add(this.config.blockClass);
        return containerElem;
    }
    createCaptionElem() {
        var ref;
        const inputElem = document.createElement("input");
        inputElem.classList.add(this.api.styles.input, this.config.captionClass);
        inputElem.placeholder = "Caption";
        if ((ref = this.state) === null || ref === void 0 ? void 0 : ref.caption) {
            inputElem.value = this.state.caption;
        }
        inputElem.addEventListener("input", (e)=>{
            if (!(e.target instanceof HTMLInputElement)) {
                return;
            }
            if (this.state) {
                this.state.caption = e.target.value.trim();
            }
        });
        return inputElem;
    }
    createInputElem() {
        const inputElem = document.createElement("input");
        inputElem.classList.add(this.api.styles.input, this.config.inputClass);
        inputElem.placeholder = "Put a link to Twitter, Instagram, Youtube and e.t.c";
        inputElem.addEventListener("input", (e)=>{
            if (!(e.target instanceof HTMLInputElement)) {
                return;
            }
            this.parse(e.target.value).then((result)=>{
                if (!result) {
                    return;
                }
                this.state = Object.assign(this.state || {}, result);
                this.renderState();
            }).catch(console.error);
        });
        return inputElem;
    }
    renderInput() {
        this.containerElem.innerHTML = "";
        this.containerElem.appendChild(this.inputElem);
        setTimeout(()=>this.inputElem.focus(), 100);
    }
    renderState() {
        var ref, ref;
        this.containerElem.innerHTML = ((ref = this.state) === null || ref === void 0 ? void 0 : ref.html) || "";
        if ((ref = this.state) === null || ref === void 0 ? void 0 : ref.scriptAfterHtmlInserted) {
            var ref;
            eval((ref = this.state) === null || ref === void 0 ? void 0 : ref.scriptAfterHtmlInserted);
        }
        this.containerElem.appendChild(this.captionElem);
    }
    refresh() {
        if (!this.state) {
            return;
        }
        const input = this.state.input;
        this.parse(input).then((result)=>{
            const state = result ? {
                input,
                html: result.html,
                url: result.url,
                scriptAfterHtmlInserted: result.scriptAfterHtmlInserted,
                provider: result.provider
            } : this.state;
            if (state) {
                this.state = Object.assign(this.state || {}, state);
                this.renderState();
            }
        }).catch(console.error);
    }
    render() {
        if (!this.state) {
            this.renderInput();
        } else {
            this.renderState();
        }
        return this.containerElem;
    }
    async parse(str) {
        for(const providerName in this.config.providers){
            const provider = this.config.providers[providerName];
            if (!provider) {
                throw new Error("Provider doesn't exist");
            }
            const result = await provider(str);
            if (typeof result !== "undefined") {
                return {
                    input: str,
                    provider: providerName,
                    url: result.url,
                    html: result.html,
                    scriptAfterHtmlInserted: result.scriptAfterHtmlInserted
                };
            }
        }
    }
    save() {
        return Object.assign(this.data, this.state);
    }
    static get toolbox() {
        return {
            title: "Embed",
            icon: '<svg style="fill: none; width: 20px; height: 20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-code"><polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline></svg>'
        };
    }
    constructor(options){
        this.data = {};
        this.events = options.events;
        this.api = options.api;
        this.config = {
            providers: options.config.providers || {},
            blockClass: options.config.blockClass || "cdx-embed-block",
            captionClass: options.config.blockClass || "cdx-embed-block__caption",
            inputClass: options.config.blockClass || "cdx-embed-block__input"
        };
        this.block = options.block;
        if (typeof options.data === "object" && options.data !== null && [
            "provider",
            "html",
            "url"
        ].every((key)=>key in options.data)) {
            this.state = options.data;
        }
        this.containerElem = this.createContainerElem();
        this.inputElem = this.createInputElem();
        this.captionElem = this.createCaptionElem();
        this.refresh();
    }
};


/***/ }),

/***/ 7840:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid--cols-5":"styles_grid--cols-5__Jug8C","grid--cols-4":"styles_grid--cols-4__X5ODM","grid--cols-3":"styles_grid--cols-3__bgw8f","grid--cols-2":"styles_grid--cols-2__W0Vdh","grid--cols-1":"styles_grid--cols-1__315JQ","grid":"styles_grid__hTqg6","grid__row":"styles_grid__row__7cxvW","grid__col":"styles_grid__col__rKTew","caption":"styles_caption__xfOt2","picture__image":"styles_picture__image__LUTQM","gradient":"styles_gradient__2pkZV","picture--with-background":"styles_picture--with-background__QMrPx","picture--with-border":"styles_picture--with-border__FwLRN"};

/***/ }),

/***/ 4842:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__UayES","content__block":"styles_content__block__eHa6L","content__block--small-bottom-margin":"styles_content__block--small-bottom-margin__yg6Aj","delimiter":"styles_delimiter__BezUh","embed__container":"styles_embed__container__vuF1g","embed--provider-twitter":"styles_embed--provider-twitter__KhD7w","embed--provider-instagram":"styles_embed--provider-instagram__GMGoX","embed__loader":"styles_embed__loader__7_CFC","embed":"styles_embed__buO47","embed__caption":"styles_embed__caption__mD01U","spin":"styles_spin__nK9d2","paragraph":"styles_paragraph__HlNP3","quote":"styles_quote__fZqZn","quote__container":"styles_quote__container__LJcI7","quote__caption":"styles_quote__caption__IMgd6","list":"styles_list__rp_8a","link":"styles_link__OveN9","link__content":"styles_link__content__CIlpy","link-in":"styles_link-in__YZkAk","link__anchor":"styles_link__anchor__nAcQv","link__description":"styles_link__description__8LLca","link__title":"styles_link__title__0ydlG","link__image":"styles_link__image__8nRE0","personality":"styles_personality__r9tXb","personality__image-container":"styles_personality__image-container__9Qq3z","personality__image":"styles_personality__image__oGLLA","personality__content":"styles_personality__content__db2L6","personality__name":"styles_personality__name__h_yyn","personality__description":"styles_personality__description__m_YUy","personality__link":"styles_personality__link__hqhHK"};

/***/ }),

/***/ 3462:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__2HgFk","link":"styles_link__gJ9rI","gradient":"styles_gradient__z_kB3","layout-5":"styles_layout-5__CSz0E","layout-5__col":"styles_layout-5__col__aHM5r","layout-5__item-1":"styles_layout-5__item-1__a6LcQ","layout-5__item-2":"styles_layout-5__item-2___bSt4","layout-5__item-3":"styles_layout-5__item-3___3iJE","layout-5__item-4":"styles_layout-5__item-4__AYz5a","layout-5__item-5":"styles_layout-5__item-5__EsQzs","layout-6":"styles_layout-6__mEsXF","layout-6__col":"styles_layout-6__col__keKKb","layout-6__item-1":"styles_layout-6__item-1__8oAQi","layout-6__item-2":"styles_layout-6__item-2__L6zNb","layout-6__item-3":"styles_layout-6__item-3__4LV3Z","layout-6__item-4":"styles_layout-6__item-4__KkO81","layout-6__item-5":"styles_layout-6__item-5__bax3O","layout-6__item-6":"styles_layout-6__item-6__bXYzi","layout-7":"styles_layout-7__tu3w_","layout-7__col":"styles_layout-7__col__NWy8U","layout-7__item-1":"styles_layout-7__item-1__HRL_Q","layout-7__item-2":"styles_layout-7__item-2__4gR_t","layout-7__item-3":"styles_layout-7__item-3__aghs2","layout-7__item-4":"styles_layout-7__item-4__11_Rk","layout-7__item-5":"styles_layout-7__item-5__Jtk3F","layout-7__item-6":"styles_layout-7__item-6__0oLIN","layout-7__item-7":"styles_layout-7__item-7__U6hHj","layout-8":"styles_layout-8__zsLS6","layout-8__col":"styles_layout-8__col__wJKYC","layout-8__item-1":"styles_layout-8__item-1__maZDo","layout-8__item-2":"styles_layout-8__item-2__0cTWa","layout-8__item-3":"styles_layout-8__item-3__vBU5h","layout-8__item-4":"styles_layout-8__item-4__1_m1o","layout-8__item-5":"styles_layout-8__item-5__M_LtA","layout-8__item-6":"styles_layout-8__item-6__NJ2gg","layout-8__item-7":"styles_layout-8__item-7__DLaDx","layout-8__item-8":"styles_layout-8__item-8__Zw3Kz","grid--cols-3":"styles_grid--cols-3__mfayU","grid__item":"styles_grid__item__x8CAA","grid__col":"styles_grid__col__g5BiH","grid--cols-2":"styles_grid--cols-2__KsqtE","grid--cols-1":"styles_grid--cols-1__mtgAJ","grid__row":"styles_grid__row__8EzU2"};

/***/ }),

/***/ 7758:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"feed":"styles_feed__AWXyB","feed__date":"styles_feed__date__0kvui","feed__date-group":"styles_feed__date-group__b1wmX","feed__post":"styles_feed__post__htaBc","feed__post--images":"styles_feed__post--images__wfbKn"};

/***/ }),

/***/ 996:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text-post":"styles_text-post__lST92","text-post__text":"styles_text-post__text__BaBex","title":"styles_title__DN4t_","title__translation-icon":"styles_title__translation-icon__Z5LBF","quote":"styles_quote__Eh0qd","quote__container":"styles_quote__container__VEJOP","quote__caption":"styles_quote__caption__jQ5iP","quote__link":"styles_quote__link__nhXS5","personality":"styles_personality__MA_8m","personality__link":"styles_personality__link__31L3t","personality__image-container":"styles_personality__image-container__p31Zr","personality__image":"styles_personality__image__Nm8Wy","personality__content":"styles_personality__content__Q_rUD","personality__name":"styles_personality__name__pcxnt","personality__description":"styles_personality__description__eEkVD"};

/***/ }),

/***/ 599:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"post":"styles_post__bLDEQ","post__meta":"styles_post__meta__JZPlm","post__content":"styles_post__content__pT6wv","meta":"styles_meta__ts88B","title":"styles_title__wV6O8","title__translation-icon":"styles_title__translation-icon__YKrTr"};

/***/ }),

/***/ 5411:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"post":"styles_post__wDMRP","post__link":"styles_post__link__5o1kt","empty":"styles_empty__mJuMu","title":"styles_title___TsQk","paragraph":"styles_paragraph__4oRJd","image":"styles_image__Kfjjm","quote":"styles_quote__yoCVH","quote--align-center":"styles_quote--align-center__RT_fS"};

/***/ }),

/***/ 6063:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__8Wn5k","form__title":"styles_form__title__sJ9ML","sidebar":"styles_sidebar__tgmD2","sidebar__item":"styles_sidebar__item__MaC6k","sidebar__item_large":"styles_sidebar__item_large__VcFL8","sidebar__label":"styles_sidebar__label__y4SFu","sidebar__topContainer":"styles_sidebar__topContainer__hfazi","sidebar__top":"styles_sidebar__top__7f7Ie","sidebar__bottom":"styles_sidebar__bottom__G593f","modal__action":"styles_modal__action___50jz"};

/***/ }),

/***/ 3546:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__4h_R5","modal__image":"styles_modal__image__UGD2E","modal__loader":"styles_modal__loader__Bv16F","spin":"styles_spin__l1kMp","unscrollable":"styles_unscrollable__ru6rh"};

/***/ }),

/***/ 382:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__VuSSO"};

/***/ }),

/***/ 9080:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__8PC3q","container_hidden":"styles_container_hidden__oPIXH","container_modal":"styles_container_modal__6Ln8e","background":"styles_background__0hl7h","modal":"styles_modal__NmY95"};

/***/ }),

/***/ 6539:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__SXMHC"};

/***/ })

}]);